// DashboardLayout.js - Updated with proper spacing
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';
import NotificationPanel from '../dashboard/NotificationPanel';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header - Fixed at top */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-200">
        <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      </div>
      
      {/* Sidebar - Fixed below header */}
      {user && (
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={() => setSidebarOpen(false)} 
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        />
      )}
      
      {/* Main content area - Adjusted based on sidebar state */}
      <main className={`
        pt-20 px-4 md:px-6 transition-all duration-300 ease-in-out
        ${user ? (isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64') : ''}
        min-h-screen
      `}>
        <div className="max-w-full mx-auto">
          <Outlet />
        </div>
      </main>
      
      <NotificationPanel />
    </div>
  );
};

export default DashboardLayout;